import { render, staticRenderFns } from "./dataV2.vue?vue&type=template&id=4c5d9f9c&"
import script from "./dataV2.vue?vue&type=script&lang=js&"
export * from "./dataV2.vue?vue&type=script&lang=js&"
import style0 from "./dataV2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports